import { useEffect, useRef, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { dict } from "@/lib/dict";
import { Loader, Empty } from "@/components/xd/ui";

const PHONE = /\+972[\d-]{8,}\d/g;
const withPhones = (html) => html.replace(PHONE, (m) => `<span dir="ltr" class="xd-phone">${m}</span>`);

const anchor = (root, hash) => {
  root.querySelectorAll("h2").forEach((h, i) => {
    h.id = `section-${i + 1}`;
    if (/^\s*8\./.test(h.textContent) && root.dataset.key === "privacy") h.id = "cookies";
  });
  if (hash) { setTimeout(() => root.querySelector(hash)?.scrollIntoView({ behavior: "smooth", block: "start" }), 120); }
};

export default function LegalPage({ pageKey }) {
  const { lang: ui, t } = useLang();
  const [params] = useSearchParams();
  const { hash } = useLocation();
  const lang = ["he", "ar"].includes(params.get("lang")) ? params.get("lang") : ui;
  const [d, setD] = useState(null);
  const ref = useRef(null);
  useEffect(() => {
    setD(null);
    api.get(`/public/pages/${pageKey}`, { params: { lang } }).then((r) => setD(r.data)).catch(() => setD({ error: true }));
  }, [pageKey, lang]);
  useEffect(() => { if (d?.html && ref.current) { anchor(ref.current, hash); } }, [d, hash]);
  useEffect(() => { document.title = `${dict[lang][`page.${pageKey}`]} · XD`; }, [pageKey, lang]);
  return (
    <div className="mx-auto max-w-3xl px-5 md:px-8 py-12 md:py-20" data-testid={`legal-page-${pageKey}`}>
      {!d ? <Loader /> : d.error ? <Empty text={t("err.generic")} /> : (
        <article ref={ref} data-key={pageKey} dir="rtl" lang={lang} className={`xd-prose xd-prose-public ${pageKey === "about" ? "xd-prose-about" : ""}`}
          dangerouslySetInnerHTML={{ __html: withPhones(d.html) }} data-testid={`legal-content-${pageKey}`} />
      )}
    </div>
  );
}
